import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { MAX_LIMIT } from 'config';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { sortOrderTypes } from 'types/shared';
import { EntityTypes, SalesTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

interface ITerritoryGridURLArgs {
  entityType: EntityTypes;
  entityIds: string[];
  salesType?: SalesTypes;
  customerFilter?: TopicFilterNames[];
  countryIds?: string[];
  download?: boolean;
  limit?: number;
  sortOrder?: sortOrderTypes;
  sortMetric?: string;
  nameFilter?: string;
  mediaTypes?: string;
  region?: string;
  customRegion?: string | string[];
  offset?: number;
}

export default function getTerritoryGridURL(
  args: ITerritoryGridURLArgs
): string {
  const {
    entityType,
    entityIds,
    salesType,
    customerFilter,
    countryIds,
    download,
    limit = MAX_LIMIT,
    sortOrder,
    sortMetric,
    nameFilter,
    mediaTypes,
    region,
    customRegion,
    offset,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = stringify({
    salesType,
    customerFilter,
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    limit,
    sortOrder,
    sortMetric,
    nameFilter,
    mediaTypes,
    ...(offset !== undefined && { offset } ),
  });

  return `/api/territory/grid/${type}/${entityIds}?${params}`;
}
